<template>

    <b-modal id="presentation-package-presentation-modal" centered size="xl" no-close-on-backdrop no-close-on-esc @close="handleCloseModal">
        <template #modal-title>{{ modalTitle }}</template>
        <div class="row">
            <div class="col-md-4">

                <div class="form-group">
                    <legend>{{ t.__('Ikona') }}</legend>
                    <file-manager-image-select :input-name="'icon'" :value="form.icon" v-model="form.icon" :mime-types="'image/jpeg,image/png'" :crop-available="true" :crop-aspect-ratio="16/9" :width="355"></file-manager-image-select>
                </div>

            </div>
            <div class="col-md-8">

                <b-form-group
                    id="my-quizzes-add-set-display-name-group"
                    description=""
                    :label="t.__('Nazwa wyświetlana (max. 40 znaków)')"
                    :disabled="processing"
                    valid-feedback=""
                    :invalid-feedback="form.errors.get('name')"
                    :state="form.errors.state('name')">
                    <b-form-input id="my-quizzes-add-set-display-name" v-model="form.name" :state="form.errors.state('name')" trim></b-form-input>
                </b-form-group>

                <p class="upload-info">{{ t.__('Dodaj materiał do swojej prezentacji. Dopuszczalne formaty to JPG, PNG, MP4.') }}<br>{{ t.__('Rozdzielczość wyjściowa plików to 1280x800px') }}.</p>

                <div class="upload-buttons">
                    <div class="upload-button" @click="uploadSlide">
                        <img src="/assets/images/upload-btn-plus.svg" alt="">
                        <div class="text">{{ t.__('Dodaj plik') }}</div>
                    </div>
                    <div class="upload-button" @click="addSlide">
                        <img src="/assets/images/upload-btn-folder.svg" alt="">
                        <div class="text">{{ t.__('Wybierz z biblioteki mediów') }}</div>
                    </div>
                </div>

            </div>
        </div>

        <p class="slides-info">{{ t.__('Podgląd układu slajdów (przeciągnij, aby zmienić kolejność)') }}</p>

        <div class="slider-box" :style="form.errors.get('slides') ? {'border-color': '#FF6515'} : {}">

            <img src="/assets/images/slide-prev.svg" class="slide-prev" alt="" @click="swipeLeft">
            <img src="/assets/images/slide-next.svg" class="slide-next" alt="" @click="swipeRight">

            <div class="slider-wrapper" ref="slider">
                <div class="slides-list">

                    <draggable tag="div" class="d-flex" :list="form.slides" v-bind="slidesDragOptions">

                        <div class="slide" v-for="(slide, index) in form.slides" :key="index" :style="{'background-color': 'black', 'background-image': 'url(' + slide.url + ')'}" :title="slide.file_name + ' (' + slideFileSize(slide.file_size) + ')'">
                            <div class="number">{{ index+1 }}</div>
                            <img class="video-icon" src="/assets/images/slide-video-icon.svg" alt="" v-if="slide.type === 'video'">
                            <div class="delete" @click="removeSlide(index)">
                                <div class="icon"></div>
                            </div>
                            <div class="processing-badge" v-if="slide.processing === 1">{{ t.__('Przetwarzanie') }} {{ slide.progress }}%</div>
                            <div class="error-badge" v-if="slide.processing === 2">{{ t.__('Błąd przetwarzania') }}</div>
                        </div>

                    </draggable>

                </div>
            </div>
        </div>

        <div class="d-block invalid-feedback" v-if="form.errors.get('slides')">{{ form.errors.get('slides') }}</div>


        <template #modal-footer="{ close }">
            <b-button variant="secondary" @click="close">{{ t.__('Anuluj') }}</b-button>
            <b-button variant="success" @click="save" :disabled="processing" v-text="processing ? t.__('Zapisuję...') : t.__('Zapisz')"></b-button>
        </template>
    </b-modal>

</template>

<script>

import draggable from 'vuedraggable'
import {inputValidators} from '../mixins/inputValidators';
import Image from "../file-manager/classes/Image";

export default {

    name: 'PresentationPackagePresentationModal',

    components: {
        draggable
    },

    mixins: [inputValidators],

    data() {
        return {
            eventHub: window.eventHub,
            action: null,
            slidesDragOptions: {
                animation: 200,
                group: 'slides',
                disabled: false,
                draggable: '.slide',
                dragoverBubble: true,
                scrollSensitivity: 200,
                forceFallback: true,
            },
            presentationIdentifier: null,
            form: new Vue.prototype.Form({
                icon: null,
                name: null,
                slides: []
            }),
            processing: false,
            mimeTypes: 'image/jpeg,image/png,video/mp4'
        }
    },

    computed: {
        modalTitle() {
            return this.action === 'add' ? t.__('Dodaj materiał') : t.__('Edytuj materiał')
        },
        slideFileSize() {
            return function (bytes, decimals = 2){
                if (!+bytes) return '0 B'

                const k = 1024
                const dm = decimals < 0 ? 0 : decimals
                const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

                const i = Math.floor(Math.log(bytes) / Math.log(k))

                return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
            }
        }
    },

    beforeMount: function () {

        this.eventHub.$on('presentation-package-update-presentations', (presentations) => {
            presentations.forEach(presentation => {
                if (presentation.identifier === this.presentationIdentifier) {
                    this.form.slides.forEach((formSlide, index) => {
                        let slide = presentation.slides.find(slide => {
                            return slide.file_name === formSlide.file_name;
                        });
                        if (slide && formSlide.new === false) {
                            this.form.slides[index].processing = slide.processing;
                            this.form.slides[index].progress = slide.progress;
                        }
                    })
                }
            })
        });

        this.eventHub.$on('presentation-package-add-presentation', () => {
            this.action = 'add';
            this.$bvModal.show('presentation-package-presentation-modal')
        });

        this.eventHub.$on('presentation-package-edit-presentation', (presentation) => {
            this.action = 'edit';
            this.presentationIdentifier = presentation.identifier;
            this.form.setData({
                icon: new Image(presentation.icon_url),
                name: presentation.name,
                slides: presentation.slides
            });
            this.$bvModal.show('presentation-package-presentation-modal')
        });

        this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
            if (modalId === 'presentation-package-presentation-modal') {
                this.action = null;
                this.form.setData({
                    icon: null,
                    identifier: null,
                    name: null,
                    slides: []
                });
            }
        });

    },

    mounted() {

        this.eventHub.$on('file-manager-selected-' + this._uid, (files) => {
            files.forEach(file => {
                this.form.slides.push({
                    new: true,
                    file: file,
                    file_name: '',
                    url: file.webPath,
                    type: file.mimeType === 'video/mp4' ? 'video' : 'image',
                });
            });
            this.eventHub.$emit('hide-file-manager');
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$refs.slider.scrollLeft = this.$refs.slider.scrollWidth;
                });
            });

        });
    },

    methods:  {

        handleCloseModal(bvModalEvent) {
            if (this.form.hasChanged()) {
                bvModalEvent.preventDefault();
                this.$bvModal.msgBoxConfirm(t.__('Czy na pewno chcesz wyjść bez zapisania zmian?'), {
                    title: t.__('Potwierdź wyjście'),
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Tak',
                    cancelTitle: 'Nie',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true,
                    bodyClass: 'exit-confirm-modal',
                })
                    .then(value => {
                        if (value) {
                            this.$bvModal.hide('presentation-package-presentation-modal');
                        }
                    })
                    .catch(err => {
                        // An error occurred
                    })
            }
        },

        scrollTo(element, scrollPixels, duration) {
            const scrollPos = element.scrollLeft;
            // Condition to check if scrolling is required
            if ( !( (scrollPos === 0 || scrollPixels > 0) && (element.clientWidth + scrollPos === element.scrollWidth || scrollPixels < 0)))
            {
                // Get the start timestamp
                const startTime =
                    "now" in window.performance
                        ? performance.now()
                        : new Date().getTime();

                function scroll(timestamp) {
                    //Calculate the timeelapsed
                    const timeElapsed = timestamp - startTime;
                    //Calculate progress
                    const progress = Math.min(timeElapsed / duration, 1);
                    //Set the scrolleft
                    element.scrollLeft = scrollPos + scrollPixels * progress;
                    //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
                    if (timeElapsed < duration) {
                        //Request for animation
                        window.requestAnimationFrame(scroll);
                    } else {
                        return;
                    }
                }
                //Call requestAnimationFrame on scroll function first time
                window.requestAnimationFrame(scroll);
            }
        },

        swipeLeft() {
            const slider = this.$refs.slider;
            this.scrollTo(slider, -215, 200);
        },

        swipeRight() {
            const slider = this.$refs.slider;
            this.scrollTo(slider, 215, 200);
        },

        uploadSlide() {
            this.eventHub.$emit('show-file-manager', this._uid, 'file', this.mimeTypes, null, false, true, true);
        },

        addSlide() {
            this.eventHub.$emit('show-file-manager', this._uid, 'file', this.mimeTypes, null, false, false, true);
        },

        removeSlide(index) {
            if (this.form.slides[index] !== undefined) {
                this.form.slides.splice(index, 1);
            }
        },

        save() {
            this.processing = true;
            if (this.action === 'add') {
                this.form.post('/presentation-package/store-presentation')
                    .then(response => {
                        this.eventHub.$emit('presentation-package-update-presentations', response.presentations, response.synchronization_status, response.last_synchronization_date, response.total_disk_space, response.used_disk_space);
                        this.processing = false;
                        this.$bvModal.hide('presentation-package-presentation-modal');
                        this.eventHub.$emit('machine-synchronization-set-status-unsynchronized');
                    })
                    .catch(error => {
                        console.log(error);
                        this.processing = false;
                    });
            } else {
                this.form.put('/presentation-package/update-presentation/' + this.presentationIdentifier)
                    .then(response => {
                        this.$bvModal.hide('presentation-package-presentation-modal');
                        this.eventHub.$emit('presentation-package-update-presentations', response.presentations, response.synchronization_status, response.last_synchronization_date, response.total_disk_space, response.used_disk_space);
                        this.eventHub.$emit('machine-synchronization-set-status-unsynchronized');
                        this.processing = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.processing = false;
                    });
            }

        }

    }

}

</script>

<style scoped>
.sortable-drag, .sortable-choosen {
    display: none !important;
}
</style>
